// 토모플레이 - 본사 - 지사별 사용량 메인 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import AgGridReactEx from "@app/components/AgGridReactEx";

import playStyle from "../../components/style";

import CardStatContent, { CardStatBranchContent } from "../../components/CardStatContent";
import ActivityList from "./ActivityList";

const Activity = forwardRef(({ selectedCheckbox, statPeriod, selectedSubOption = "N", updateViewSubOption, onViewSubOptionSelected }, ref) => {
    const [subOptionApplied, setSubOptionApplied] = useState(false);
    const [stat, setStat] = useState(false);
    const [statData, setData] = useState(false);
    const [categoryList, setCategoryList] = useState(false);
    const [sortOption, setSortOption] = useState({ colId: "nurseryName", sort: "asc" });

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: `토모플레이 콘텐츠 별 통계`,
                sheets: [
                    {
                        name: "콘텐츠",
                        title: `토모플레이 지사 (${selectedSubOption}) 통계`,
                        columnTitle: ["콘텐츠 명", "열람 메뉴", "카테고리", "과목", "콘텐츠 유형", "수준", "순 실행 수", "누적 실행 수"],
                        data: statData,
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        setStat(false);
        if (selectedSubOption) {
            axios({
                method: "POST",
                url: `/api/play_stat/play/contents`,
                data: {
                    startDate: statPeriod.startDate,
                    endDate: statPeriod.endDate,
                    periodType: statPeriod.type,
                    type: selectedSubOption,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        var stat = result.data.data;
                        var tableData = [];
                        stat.activity.map((s) => {
                            let menu = playStyle.seriesPlayChart.find((f) => f.field == s.menu);
                            let category = stat.categoryList.find((f) => f.id == s.subCategory);
                            let age = playStyle.seriesAgeChart.find((f) => f.field == s.age);
                            let contentType = playStyle.seriesActivityType.find((f) => f.service == s.service && f.id == s.type);
                            if (selectedCheckbox != "Y") {
                                if ((s.todayPlayCount > 0 || s.todayPlayCountSum > 0) && (selectedSubOption == s.age || selectedSubOption == "-")) {
                                    tableData.push({
                                        contentName: s.contentName,
                                        type: "오늘 토모랑",
                                        menu: menu ? menu.name : null,
                                        subCategory: category ? category.name : null,
                                        contentType: contentType ? contentType.name : "오디오",
                                        age: age.name,
                                        playCount: s.todayPlayCount,
                                        playCountSum: s.todayPlayCountSum,
                                    });
                                }
                                if ((s.allPlayCount > 0 || s.allPlayCountSum > 0) && (selectedSubOption == s.age || selectedSubOption == "-")) {
                                    tableData.push({
                                        contentName: s.contentName,
                                        type: "모두 보기",
                                        menu: menu ? menu.name : null,
                                        subCategory: category ? category.name : null,
                                        contentType: contentType ? contentType.name : "오디오",
                                        age: age.name,
                                        playCount: s.allPlayCount,
                                        playCountSum: s.allPlayCountSum,
                                    });
                                }
                            } else {
                                if ((selectedSubOption == s.age || selectedSubOption == "-") && s.allPlayCount + s.todayPlayCount + s.allPlayCountSum + s.todayPlayCountSum > 0) {
                                    tableData.push({
                                        contentName: s.contentName,
                                        type: "-",
                                        menu: menu ? menu.name : null,
                                        subCategory: category ? category.name : null,
                                        contentType: contentType ? contentType.name : "오디오",
                                        age: age.name,
                                        playCount: s.allPlayCount + s.todayPlayCount,
                                        playCountSum: s.allPlayCountSum + s.todayPlayCountSum,
                                    });
                                }
                            }
                        });

                        setStat(stat);
                        setData(tableData);
                        setCategoryList(stat.categoryList);
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    }, [statPeriod, selectedSubOption, selectedCheckbox]);
    useEffect(() => {
        if (!subOptionApplied && updateViewSubOption) {
            updateViewSubOption(
                [
                    { name: "전체", id: "-" },
                    { name: "만 3세", id: "1" },
                    { name: "만 4세", id: "2" },
                    { name: "만 5세", id: "3" },
                    { name: "혼합", id: "123" },
                ],
                "-"
            );
            setSubOptionApplied(true);
        }
        getStat();
        return () => {};
    }, [getStat, subOptionApplied]);

    function onListSortChanged(colId, sort) {
        setSortOption({ sortOption: { colId, sort } });
    }
    return (
        <div className="stat-branch-content">
            <div>
                <div className="row">
                    <div className="col">
                        <ActivityList data={statData} onListSortChanged={onListSortChanged.bind(this)} />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Activity;
